/* eslint-disable */
import TagManager from 'react-gtm-module';

export default (dataLayer: Object) => {
  TagManager.dataLayer({ dataLayer });
};
